/**
 * Enum which represents the type of a node within the area tree. This value is computed in the UI.
 * A node type of undefined indicates a group.
 */
export enum AreaTreeNodeType {
	// Internal node types
	Group = undefined,
	Container = 1,

	// Additional node types
	Camera = 2,
	Door = 3,
	Zone = 4
}
